import Pn from '@/models/pn'
import BtnIcon from '@/components/button/BtnIcon'

export default {
  components: {
    BtnIcon
  },
  props: {
    value: Object
  },
  data: () => ({
    loading: false,
    deleting: false,
  }),
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    pn () {
      return Pn
    }
  },
  watch: {
    deleting (value) {
      this.localValue._discard = value
    },
  },
  created () {
    this.deleting = false
  },
}
